import {ADOBE_GAME_NAME} from "modules/constants";
import i18n from "i18next";
import {User} from "modules/utils";

interface IAnalyticsProps {
	section: string;
	eventName?: string;
	videoName?: string;
	voteSource?: string;
	score?: number;
	productTile?: string;
	socialShareType?: string;
	socialShareSource?: string;
	userStatus?: string;
	playerID?: number;
	teamID?: number;
}

let trackEvent = "pageLoad";

const getUserStatus = () => {
	return User.IS_AUTHENTICATED() ? "logged in" : "not logged in";
};

export const trackAdobeAnalytics = ({section, eventName, ...other}: IAnalyticsProps) => {
	const pageName = `games:${ADOBE_GAME_NAME}${section}:microsite`;
	const dataLayerEvent = eventName || trackEvent;

	if (window.dataLayer) {
		window.dataLayer.push({
			event: dataLayerEvent,
			// fifaspid: '',
			// fifaId: '',
			// userCountry: '', // Commented lines are for SSO
			userLanguage: i18n.language,
			userStatus: getUserStatus(),
			pageName,
			language: i18n.language,
			...other,
		});
		if (trackEvent === "pageLoad") {
			trackEvent = "viewChange";
		}
	}
};

export function trackAdobeAnalyticsPureViewChange(section: string) {
	if (!window.dataLayer) {
		console.warn("No window.dataLayer found");
		return;
	}

	window.dataLayer.push({
		event: "viewChange",
		pageName: `worldcup:qatar2022:games:${ADOBE_GAME_NAME}:${section}`,
		language: i18n.language,
		userStatus: getUserStatus(),
	});
}

export function trackAdobeAnalyticsPureEvent(event: string, section: string) {
	if (!window.dataLayer) {
		console.warn("No window.dataLayer found!");
		return;
	}

	window.dataLayer.push({
		event,
		pageName: `worldcup:qatar2022:games:${ADOBE_GAME_NAME}:${section}`,
		language: i18n.language,
		userStatus: getUserStatus(),
	});
}

export function trackAdobeAnalyticsPure(data: Record<string, string | number>) {
	if (!window.dataLayer) {
		console.warn("No window.dataLayer found!");
		return;
	}

	window.dataLayer.push({
		...data,
		language: i18n.language,
		userStatus: getUserStatus(),
	});
}
